import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = { class: "icon" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(!_ctx.loading ? `button is-${_ctx.color} is-outlined` : `button is-${_ctx.color} is-outlined is-loading`),
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clicado && _ctx.clicado(...args))),
    disabled: _ctx.desabilitado
  }, [
    _createElementVNode("span", _hoisted_2, [
      _createElementVNode("i", {
        class: _normalizeClass(_ctx.icone)
      }, null, 2)
    ]),
    _createElementVNode("span", null, _toDisplayString(_ctx.texto), 1)
  ], 10, _hoisted_1))
}